import { IWebsiteBuilderFormRaw } from "redux/reducers/models/websiteBuilder";
import { IFormBuilderRow } from "./formBuilderRow";
import { IFormBuilderDesignStyles } from "./formBuilderDesignStyles";
import { CSSProperties } from "react";

export const FORM_BUILDER_FORM_GAP = 16;

export interface IFormBuilderFormSettings {
  name: string;
  emailNotificationsEnabled: boolean;
}

export interface IFormBuilderForm {
  id: number;
  key: string;
  websiteId: number;
  updatedAt: string;
  archivedAt: string;
  settings: IFormBuilderFormSettings;
  children: IFormBuilderRow[];
}

export type TFormBuilderFormSettings = IFormBuilderForm["settings"];

export function isWebsiteBuilderFormRawValid(rawForm: IWebsiteBuilderFormRaw): boolean {
  return (
    rawForm?.id != null &&
    rawForm?.website_id != null
  );
}

function generateDefaultFormSettings(): IFormBuilderFormSettings {
  return {
    name: "Form", // TODO: Translation
    emailNotificationsEnabled: false,
  };
}

export function formBuilderGenerateDefaultForm(websiteId: number): IFormBuilderForm {
  return {
    id: null,
    key: crypto.randomUUID(),
    websiteId,
    updatedAt: null,
    archivedAt: null,
    settings: generateDefaultFormSettings(),
    children: [],
  };
}

export function formBuilderGenerateFormDesignStyles(): IFormBuilderDesignStyles {
  const styleProperties: CSSProperties = {
    gap: `${FORM_BUILDER_FORM_GAP}px`,
  };

  const styleDeclaration = `gap: ${styleProperties.gap};`;
  
  return {
    className: "form-builder-form",
    styleProperties,
    styleDeclaration,
  };
}